<template>
  <div>
    <div class="d-flex flex-column pa-1">
      <v-btn
        width="90%"
        depressed
        small
        v-for="(type, index) in medTypes"
        :key="index"
        :dark="storeDetail == type.type"
        :to="'/meds/category/' + type.type"
        class="my-1 mx-auto"
        >{{ type.title }}</v-btn
      >
    </div>
    <!-- <med-browsing-options class="text-center"></med-browsing-options> -->
    <div class="d-flex flex-column my-3 pa-1">
      <v-btn
        v-for="option in browseOptions"
        :key="option.label"
        @click="browsePicked(option.route)"
        color="#eaf2f6"
        width="90%"
        depressed
        small
        class="my-1 mx-auto"
      >
        <v-icon small class="mx-3" v-if="option.icon"
          >mdi-{{ option.icon }}</v-icon
        >
        <v-img
          :src="option.image"
          class="mx-3"
          width="25"
          contain
          v-if="option.image"
        />
        <span style="width: 70%">
          {{ $vuetify.breakpoint.lgAndUp ? option.label : option.shortLabel }}
        </span>
      </v-btn>
    </div>
  </div>
</template>

<script>
// note this has watchers for loading, mode, and detail
// this component must have data.mode:"something"
// and must have methods for detailChange(detail)
import WatcherMixin from "@/assets/js/WatcherMixin";
import MedCategories from "@/assets/js/meds/MedCategories";
// import MedBrowsingOptions from "./MedBrowsingOptions.vue";

export default {
  components: {
    // MedBrowsingOptions,
  },
  name: "MedCategoryBtns",
  mixins: [WatcherMixin],
  props: {},
  data: function () {
    return {
      mode: "category",
      isCurrentMode: false,
      selectedTypeIndex: null,

      browseOptions: [
        {
          label: "Systemic Meds",
          shortLabel: "Systemic Meds",
          route: "Orals",
          icon: "pill",
        },
        {
          label: "Cap Colors",
          shortLabel: "Cap Colors",
          route: "CapColors",
          image: "https://www.eyedock.com/images/meds/bottle_red.svg",
        },
        {
          label: "Companies",
          shortLabel: "Companies",
          route: "MedCompanies",
          icon: "factory",
        },
        {
          label: "Ingredients",
          shortLabel: "Ingredients",
          route: "MedIngredients",
          icon: "flask-outline",
        },
        {
          label: "MOAs",
          shortLabel: "MOAs",
          route: "MedMoas",
          icon: "auto-fix",
        },
      ],
    };
  },
  methods: {
    browsePicked(route) {
      this.dialog = false;
      this.$router.push({ name: route });
    },
  },
  computed: {
    medTypes: function () {
      return MedCategories.medTypes;
    },
  },
};
</script>

<style scoped></style>
